import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fetchAllPlans, fetchMyPlans, makeaPlan, resetCreatePlan } from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { PaystackButton } from "react-paystack";
import { fetchPricing } from "../redux/slices/homeSlice";

const PricingRap = styled.div`
margin-top: 125px;
  background: #ffffff;
  border: 1px solid #bac0d499;
    border-radius: 20px;
  padding: 40px;

.all-dropdown-div {
  padding: 20px;  
}


  .paystack-btn {
background: red;
  color: #fff;
  padding: 12px 20px;
  border: none;
  border-radius: 100px;
    width: 147px;
       height: 40px;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}
  .price-1 p {
    color: #363d4f;
    font-weight: 16px;
    font-weight: 400;
    text-align: center;
  }
  .price-1 h2 {
    color: #060b13;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    line-height: 45px;
  }
  .price-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  
  }
  .link-contain {
    width: 176px;
    height: 40px;
    padding: 4px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    border: 1px solid #e4e4e7;
  }
  .link {
    text-decoration: none;
    width: 88px;
    padding: 8px 16px;
    color: #a1a1aa;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .link.active {
    background: #ed1c241a;
    color: #ed1c24;
    border-radius: 100px;
  }
  .price-2-upper p {
    color: #ed1c24;
    font-weight: 700;
    font-size: 12px;
  }
  .price-2-upper {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .price-card-sub-1 h5 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .price-card-sub-1 p {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
  }
  .card-started-btn {
    width: 256px;
    height: 50px;
    border-radius: 100px;
    border-right: 5px;
    border-left: 2px;
    border-bottom: 5px;
    border-top: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    border-style: solid;
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
    border-color: #060b13;
  }
  .price-card-sub-2 h5 {
    color: #060b13;
    font-size: 32px;
    font-weight: 700;
  }
  .price-card-sub-2 p {
    color: #060b13;
    font-size: 12px;
    font-weight: 400;
  }
  .price-card-sub-2 {
    display: flex;
    align-items: flex-end;
  }
  .card-task p {
    color: #060b13;
    font-size: 12px;
    font-weight: 400;
  }
  .card-task {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .price-card-sub-3 h6 {
    color: #060b13;
    font-size: 16px;
    font-weight: 500;
  }
  .price-card-sub-3 {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .price-card {
    background: #FFFFFF;
    border: 0.8px solid #BAC0D4B2;
    border-radius: 8px;
    padding: 20px;
    max-width: 288px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: fit-content;
  }
  .price-card-header {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: center;
    padding: 6px 8px;
    background: #ED1C24;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }
  .red-pride-card {
    padding: 0px;
  }
  .price-card-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .colored-btn {
    background: #ED1C24;
    color: #ffffff;
  }
  .price-3 {
    display: grid;
    gap: 20px;
    margin-top: 40px;
    grid-template-columns: repeat(3, 1fr);
  }
  .price-2 {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .sub-price-5-1 p {
    color: #363D4F;
    font-size: 16px;
    line-height: 18px;
    font-weight: 400;
    text-align: center;
  }
  .sub-price-5-1, .sub-price-5-2 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .sub-price-5-2 h2 {
    color: #171717;
    font-size: 40px;
    font-weight: 700;
    line-height: 45px;
    align-items: center;
  }
  .sub-price-5-2 p {
    color: #596780;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    text-align: center;
  }
  .sum-price-6 p {
    color: #171717;
    font-weight: 500 !important;
    font-size: 20px !important;
  }
  .sum-price-6 {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
  }
  .sodium-text p {
    color: #363D4F;
    font-weight: 400;
    font-size: 12px;
    max-width: 768px;
  }
  .sodium-text {
    border-bottom: 1px solid #BAC0D480;
    padding: 24px 0px;
    width: 768px;

  }
  .all-sodium-div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .price-5 {
    display: flex;
    flex-direction: column;
    gap: 70px;
    margin: 100px 0px;
  }
  @media (max-width: 1230px) {
.price-3 {
    grid-template-columns: repeat(2, 1fr);
}
  }
    @media (max-width: 1120px) {
.price-3 {
    grid-template-columns: repeat(3, 1fr);
}
  }

    @media (max-width: 992px) {
.price-3 {
    grid-template-columns: repeat(2, 1fr);
}
  }


  @media (max-width: 800px) {
    .sodium-text {
        width: 600px;
    }
  }
  @media (max-width: 650px) {
    .sodium-text {
        width: 450px;
    }
    .price-3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    }
  }
  @media (max-width: 470px) {
    .sodium-text {
        width: 300px;
    }
  }
  @media (max-width: 320px) {
    .sodium-text {
        width: 250px;
    }
  }
`;

const Pricing = () => {
const navigate = useNavigate();
          const userDta = JSON.parse(localStorage.getItem("pluglrUserDetails"));
 const { userAllPlans, userMyPlans, planloading,  planSuccess, userEvents, eventloading, userData,  error } =
    useSelector((state) => state.userData);


      const dispatch = useDispatch();
        const { pricingObject, loading } = useSelector((state) => state.content);
        console.log(pricingObject);
    
    
  const [activeLink, setActiveLink] = useState("yearly");
const [openS, setOpenS] = useState(false)
const [openSo, setOpenSo] = useState(false)
const [openSod, setOpenSod] = useState(false)
const [openSodi, setOpenSodi] = useState(false)
const [openSodiu, setOpenSodiu] = useState(false)
const [openSodium, setOpenSodium] = useState(false)
const [amountNew, setAmount] = useState(null)
const [planType, setPlanType] = useState("")
const [showModal, setShowModal] = useState(false);

   const [propData, setPropData] = useState (
    {
  id:   userDta?.id,
  monthlyPlan:  false,
  price: amountNew,
  dateCreated: "",
  planType: planType,
})

 useEffect(() => {
  setPropData(prev => ({
    ...prev,
    monthlyPlan: activeLink === "monthly",
  }));
}, [activeLink]);


console.log( propData);
  const publicKey = "pk_test_d929bbd3b478f8fe2b0ac9fa6b368d5b52eeceb5"; // replace with your Paystack PUBLIC key

const amount = amountNew * 100
const email = userDta?.email;
const name = userDta?.fname + " " + userDta?.lname;

  const componentProps = {
  email,
  amount,
  metadata: {
    name,
  },
  publicKey,
  text: "Pay Now",
 onSuccess: (response) => {
  console.log("Payment success:", response);

  const updatedPropData = {
    ...propData,
    price: amountNew,
    planType: planType,
    dateCreated: Date.now(), // timestamp in ms
  };

  dispatch(makeaPlan(updatedPropData));
},
  onClose: () => alert("Payment closed without completion."),
};



 

    console.log(userAllPlans);

    const pricing = userAllPlans?.data || [];

    console.log(pricing);
    
    
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };


const handleClose = () => {
  dispatch(resetCreatePlan())
  setShowModal(false);
}

   useEffect(() => {
      dispatch(fetchAllPlans());
    }, [dispatch]);

 useEffect(() => {
      dispatch(fetchMyPlans());
    }, [dispatch]);

    useEffect(() => {
      dispatch(fetchPricing());
    }, [dispatch]);

const pricingData = pricingObject?.data?.pricing


const handleLogin = () => {
  navigate("/login")
}

  return (
    <PricingRap>
    <div >
      <div className="price-1">
        <h2>{pricingData?.priceHeading?.title}</h2>
        <p>{pricingData?.priceHeading?.sub_title}</p>
          <div className="price-2-upper">
          <p>{pricingData?.priceHeading?.discount}</p>
          <div className="link-contain">
            <Link
              className={`link ${activeLink === "yearly" ? "active" : ""}`}
              to=""
              onClick={() => handleLinkClick("yearly")}
            >
              Yearly
            </Link>
            <Link
              className={`link ${activeLink === "monthly" ? "active" : ""}`}
              to=""
              onClick={() => handleLinkClick("monthly")}
            >
              Monthly
            </Link>
          </div>
        </div>
      </div>
      <div className="price-2">
      
        <div className="price-3">
{pricingData?.priceList?.map((plan) => (
  <div className="price-card" key={plan.id}>
    <div className="price-card-sub-1">
      <h5>{plan.package_name}</h5>
      <p>{plan.title}</p>
    </div>

    <div className="price-card-sub-2">
      <h5>
        {activeLink === "monthly" ? plan.monthly_price : plan.yearly_price}
      </h5>
      <p>{activeLink === "monthly" ? "/month" : "/year"}</p>
    </div>

   <button
  className="card-started-btn"
  onClick={
    handleLogin

    // setAmount(activeLink === "monthly" ? plan.monthly_price : plan.yearly_price);
    // setPlanType(plan.package_name);
    // setShowModal(true); // open modal
  }
>
  Get Started
</button>



            <div className="price-card-sub-3">
  <h6>What you get:</h6>

  {/* Parse and display dynamic details */}
  {plan.details && (() => {
    try {
      const details = JSON.parse(plan.details);
      return details.map((item, index) => (
        <div className="card-task" key={index}>
          <Icon
            width="24px"
            height="24px"
            icon="fluent-mdl2:check-mark"
            style={{ color: "#ed1c24" }}
          />
          <p>{item.title}</p>
        </div>
      ));
    } catch (error) {
      console.error("Invalid details JSON:", error);
      return <p>Unable to load details</p>;
    }
  })()}
</div>

          </div>
          ))}
          
         
        </div>
      </div>
      </div>
    {showModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        width: "min(90vw, 440px)",
        maxHeight: "80vh",
        overflowY: "auto",
        textAlign: "center",
      }}
    >
      <h2>Confirm Subscription</h2>
      <p>
        You want to subscribe to <b>{planType}</b> plan costing{" "}
        <b>
          {amount} {activeLink === "monthly" ? "/month" : "/year"}
        </b>
      </p>

      <div style={{ marginTop: "20px" }}>
        <button
          onClick={() => setShowModal(false)}
          style={{ marginRight: "10px", padding: "8px 16px" }}
        >
          Cancel
        </button>
                                      <PaystackButton {...componentProps}  className="paystack-btn" />

      </div>
    </div>
  </div>
)}

            {planloading ? (
                  <div className="dropdown-container">
                    <ClipLoader color="white" size={100} />
                  </div>
                ): ""}

                {planSuccess ? (
      <div className="dropdown-container">

        <div className="all-dropdown-div">
          <p style={{
            fontSize: "20px",
            fontWeight: "600",
            textAlign: "center",
            lineHeight: "23px"
          }}>Payment made sucessfully. <br /> Thanks</p>

             <button onClick={handleClose} style={{ 
          width: "100%",
          height: "40px",
          background: "red",
          color: "white",
          border: "none"

        }}>Close</button>
        </div>
     
      </div>
    ): ""}

    </PricingRap>
  );
};

export default Pricing;
